// removed by extract-text-webpack-plugin
module.exports = {"stage":"styles-stage--lAUlv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StageComparison/styles.scss
// module id = V/ra
// module chunks = 3